import React from 'react';
import {
  TextInput,
  FormItem,
  Form,
  FormGroup,
  DatePicker,
  DatePickerInput,
  Modal,
  Loading,
  Checkbox,
} from 'carbon-components-react';
import CustomButton from '../../custom-button/custom-btn.component';

import './add-term.styles.scss';
import { isDateValid } from '../../../utils/common.util';
import { addOrUpdateTerm } from '../../../api/academic-year.service';
import { createStructuredSelector } from 'reselect';
import { selectCurrentUser } from '../../../redux/selectors/user.selectors';
import { setTerms } from '../../../redux/actions/academic-year.actions';
import { connect } from 'react-redux';

class AddTermModal extends React.Component {
  constructor(props) {
    super(props);

    // set state
    this.state = {
      openModal: props.openModal,
      id: 0,
      academicYearId: props.academicYearId,
      termToEdit: this.props.term,
      description: '',
      startDate: '',
      endDate: '',
      semester: false,
      loading: false,
      errorMessage: null,
      btnText: 'ADD',
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.openModal !== prevState.openModal) {
      return { openModal: nextProps.openModal };
    } else return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.academicYearId !== prevProps.academicYearId) {
      this.setState({ academicYearId: this.props.academicYearId });
    }

    if (this.props.term !== prevProps.term) {
      if (this.props.term) {
        const startDate = new Date(this.props.term.startDate);
        const endDate = new Date(this.props.term.endDate);

        const parsedStartDate = [
          startDate.getFullYear(),
          ('0' + (startDate.getMonth() + 1)).slice(-2),
          ('0' + startDate.getDate()).slice(-2),
        ].join('-');

        const parsedEndDate = [
          endDate.getFullYear(),
          ('0' + (endDate.getMonth() + 1)).slice(-2),
          ('0' + endDate.getDate()).slice(-2),
        ].join('-');

        console.log(parsedStartDate, parsedEndDate);

        this.setState({
          id: this.props.term.id,
          termToEdit: this.props.term,
          description: this.props.term.description,
          startDate: parsedStartDate,
          endDate: parsedEndDate,
          semester: this.props.semester,
          btnText: 'UPDATE',
        });
      } else {
        this.setState({
          id: 0,
          termToEdit: null,
          description: '',
          startDate: '',
          endDate: '',
          semester: false,
          btnText: 'ADD',
        });
      }
    }
  }

  // handle onchange event handler for input fields
  handleChange = (event) => {
    // destructure value and name of event.target
    const { value, name } = event.target;
    // update state
    this.setState({ [name]: value });
  };

  // validate data entered
  validateData = () => {
    return (
      this.state.academicYearId > 0 &&
      this.state.description.length > 0 &&
      this.state.startDate.length > 0 &&
      this.state.endDate.length > 0 &&
      isDateValid(this.state.startDate) &&
      isDateValid(this.state.endDate)
    );
  };

  createTerm = async (event) => {
    event.preventDefault();

    // update state to set request in progress to true and error occurred to false
    this.setState({
      loading: true,
      errorMessage: null,
      btnText: null,
    });

    // build data
    const data = {
      id: this.state.id,
      academicYearId: this.state.academicYearId,
      description: this.state.description,
      startDate: this.state.startDate,
      endDate: this.state.endDate,
      semester: this.state.semester,
    };

    // initiate request
    const response = await addOrUpdateTerm(
      this.props.currentUser.authToken,
      data,
    );

    if (!response.success) {
      this.setState({
        loading: false,
        errorMessage: response.message,
        btnText: this.state.termToEdit ? 'UPDATE' : 'ADD',
      });

      return;
    }

    // on success
    this.setState({
      loading: false,
      id: 0,
      description: '',
      startDate: '',
      endDate: '',
      semester: false,
      btnText: this.state.termToEdit ? 'UPDATE' : 'ADD',
    });

    // update redux
    this.props.setTerms([response.term]);

    // close dialog
    this.props.cancelAction();
  };

  render() {
    return (
      <Modal
        id="add-term-modal"
        className="add-term-modal"
        hasScrollingContent
        passiveModal={true}
        open={this.state.openModal}
        modalHeading={
          this.state.termToEdit ? 'Edit Term/Semester' : 'Add New Term/Semester'
        }
        primaryButtonDisabled={false}>
        <div>
          <Form action="post">
            <FormGroup legendText="">
              <FormItem>
                <TextInput
                  id="description"
                  name="description"
                  labelText="Description"
                  placeholder="E.g. 1ST TERM or 1ST SEMESTER"
                  value={this.state.description}
                  onChange={this.handleChange}
                />
              </FormItem>
            </FormGroup>

            <FormGroup>
              <FormItem>
                <DatePicker
                  dateFormat="Y-m-d"
                  datePickerType="single"
                  id="start-date-picker"
                  onClose={(value) => {
                    if (value.length > 0) {
                      this.setState({
                        startDate: [
                          value[0].getFullYear(),
                          ('0' + (value[0].getMonth() + 1)).slice(-2),
                          ('0' + value[0].getDate()).slice(-2),
                        ].join('-'),
                      });
                    }
                  }}>
                  <DatePickerInput
                    className="start-date"
                    id="start-date"
                    name="startDate"
                    labelText="Start Date"
                    value={this.state.startDate}
                    onChange={this.handleChange}
                    pattern="d{1,2}/d{4}"
                    placeholder="YYYY-MM-DD"
                    type="text"
                  />
                </DatePicker>
              </FormItem>
            </FormGroup>

            <FormGroup>
              <FormItem>
                <DatePicker
                  dateFormat="Y-m-d"
                  datePickerType="single"
                  id="end-date-picker"
                  onClose={(value) => {
                    if (value.length > 0) {
                      this.setState({
                        endDate: [
                          value[0].getFullYear(),
                          ('0' + (value[0].getMonth() + 1)).slice(-2),
                          ('0' + value[0].getDate()).slice(-2),
                        ].join('-'),
                      });
                    }
                  }}>
                  <DatePickerInput
                    className="end-date"
                    id="end-date"
                    name="endDate"
                    labelText="End Date"
                    value={this.state.endDate}
                    onChange={this.handleChange}
                    pattern="d{1,2}/d{4}"
                    placeholder="YYYY-MM-DD"
                  />
                </DatePicker>
              </FormItem>
            </FormGroup>

            <FormGroup
              legendText=""
              className="nmb"
              hidden={this.state.termToEdit}>
              <FormItem style={{ marginTop: '0' }}>
                <Checkbox
                  id="semester"
                  name="semester"
                  labelText="Semester ?"
                  checked={this.state.semester}
                  onChange={(value) => this.setState({ semester: value })}
                />
              </FormItem>
            </FormGroup>

            <p className="text-grey mt-10 text-14">
              Hint: 3 Terms for KG/Primary, 2 Semesters for JHS.
            </p>

            <CustomButton
              classes="primary f-width mt-30 font-bold"
              disabled={!this.validateData() || this.state.loading}
              onClick={this.createTerm}>
              {this.state.btnText}

              <div hidden={this.state.btnText != null}>
                <div className="d-flex-center">
                  <Loading
                    withOverlay={false}
                    small={true}
                    description="adding term..."
                  />
                </div>
              </div>
            </CustomButton>

            <p
              className="text-14 mt-10 text-danger"
              hidden={this.state.errorMessage === null}
              disabled={this.state.loading}>
              {this.state.errorMessage}
            </p>

            <CustomButton
              classes="outline danger f-width mt-20 font-bold"
              onClick={() => {
                this.setState({
                  loading: false,
                  errorMessage: null,
                });

                this.props.cancelAction();
              }}>
              CANCEL
            </CustomButton>
          </Form>
        </div>
      </Modal>
    );
  }
}

// this will provide us with the state values we need
const mapStateToProps = createStructuredSelector({
  currentUser: selectCurrentUser,
});

// this allows us to map our redux actions to our component
const mapDispatchToProps = (dispatch) => ({
  setTerms: (terms) => dispatch(setTerms(terms)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddTermModal);
